import React, { useEffect, useState } from "react";
import BarChart from "../../../statistic/BarChart";
import { useSelector } from "react-redux";
import styled from "styled-components";

const ProjectsBudgetAverage = ({ selectedProjects }) => {
  const { projects } = useSelector((state) => state.projects);
  const initialValue = 0;
  const [strategicProjects, setStrategicProjects] = useState([]);

  useEffect(() => {
    setStrategicProjects(
      (selectedProjects || projects || []).filter(
        (p) => p.isStrategic === true
      )
    );
  }, [selectedProjects, projects]);

  const [realBudgetsSum, setRealBudgetsSum] = useState();
  const [realInvestmentSum, setRealInvestmentSum] = useState();
  const [realExploitationSum, setRealExploitationSum] = useState();
  const [estimatedInvestmentSum, setEstimatedInvestmentSum] = useState();
  const [estimatedExploitationSum, setEstimatedExploitationSum] = useState();
  const [estimatedBudgetsSum, setEstimatedBudgetsSum] = useState();

  useEffect(() => {
    let nonOptionalBudgetsList = strategicProjects.filter(
      (p) => p.isBudgetOptional === false
    );
    let realInvestmentBudget = nonOptionalBudgetsList.map((p) => p.realInvestmentBudget);
    let estimatedInvestmentBudget = nonOptionalBudgetsList.map((p) => p.estimatedInvestmentBudget);
    let realExploitationBudget = nonOptionalBudgetsList.map((p) => p.realExploitationBudget);
    let estimatedExploitationBudget = nonOptionalBudgetsList.map((p) => p.estimatedExploitationBudget);
    let realBudgetsList = nonOptionalBudgetsList.map((p) => p.realInvestmentBudget + p.realExploitationBudget);
    let estimatedBudgetsList = nonOptionalBudgetsList.map(
      (p) => p.estimatedInvestmentBudget + p.estimatedExploitationBudget
    );
    setRealBudgetsSum(
      realBudgetsList.reduce(
        (prevValue, currentValue) => prevValue + currentValue,
        initialValue
      )
    );
    setEstimatedBudgetsSum(
      estimatedBudgetsList.reduce(
        (prevValue, currentValue) => prevValue + currentValue,
        initialValue
      )
    );
    setRealInvestmentSum(
        realInvestmentBudget.reduce(
            (prevValue, currentValue) => prevValue + currentValue,
            initialValue
        )
    )
    setEstimatedInvestmentSum(
        estimatedInvestmentBudget.reduce(
            (prevValue, currentValue) => prevValue + currentValue,
            initialValue
        )
    )

    setRealExploitationSum(
        realExploitationBudget.reduce(
            (prevValue, currentValue) => prevValue + currentValue,
            initialValue
        )
    )
    setEstimatedExploitationSum(
        estimatedExploitationBudget.reduce(
            (prevValue, currentValue) => prevValue + currentValue,
            initialValue
        )
    )
  }, [strategicProjects]);

  const [budgetsData, setBudgetsData] = useState({});

  useEffect(() => {
    setBudgetsData({
      labels: ["Budget"],
      datasets: [
        {
          label: "Total estimé",
          data: [estimatedBudgetsSum],
          backgroundColor: "rgba(73, 9, 170, 0.7)",
        },
        {
          label: "Total réel",
          data: [realBudgetsSum],
          backgroundColor: "rgba(51, 148, 246, 0.7)",
        },
      ],
    });
  }, [estimatedBudgetsSum, realBudgetsSum]);

  return (
      <>
        <h2>Budget reel et estimé des projets (en €)</h2>
          <BarChart chartData={budgetsData} />
          <Detail>
            <h2>Investissement estimé : {estimatedInvestmentSum} €</h2>
            <h2>Investissement réel : {realInvestmentSum} € </h2>
            <h2>Exploitation estimé : {estimatedExploitationSum} € </h2>
            <h2>Exploitation réel : {realExploitationSum} € </h2>
          </Detail>
      </>
  );
};

const Detail = styled.div`
  display: flex;
  flex-direction: column;
  text-align: left;
  padding: 2rem 10rem;
  border-radius: 5px;
  box-shadow: rgba(0,0,0,0.12) 0 6px 16px;
`
export default ProjectsBudgetAverage;
